import React from 'react';
import _ from "lodash";
import ThemedBlockTitle from "components/atoms/ThemedBlockTitle";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedList from 'components/atoms/ThemedList'
import ThemedBlockListContainer from 'components/atoms/ThemedBlockListContainer'
import HelperString from 'utils/helper-string'
import { themedSectionListStyles } from 'styles/components/atoms/ThemedSectionList'
import VStack from 'components/atoms/stack/VStack'

const ThemedSectionList = ({ sections = [], header, renderItem }) => {
	
	let themedBlockProps = {};
	
	// No header? Add props for it
	if( header === undefined ) {
		themedBlockProps = {
			...themedBlockProps,
			mediumPadding: true,
			shadow: true
		}
	}
	
	const content = [];
	_.forEach( sections, section => {
		if( _.size( section.data ) > 0 ) {
			const hasSubtitle = _.get( section, 'subtitle', null ) !== null;
			
			content.push(
				<VStack
					key={ HelperString.hash( `building-block-section-${ section.booking_date ?? 'bb' }-${ section.uniqueKey ?? 'aa' }`, section.title ) }>
						
					<ThemedBlock
						smallPadding
						{ ...themedBlockProps }>
						
						<ThemedBlockTitle
							style={ hasSubtitle ? themedSectionListStyles.viewHasSubtitle : null }>
							
							{ section.title }
						</ThemedBlockTitle>
						
						{ hasSubtitle && (
							<ThemedBlockTitle
								textHint
								textMedium>
								
								{ section.subtitle }
							</ThemedBlockTitle>
						)}
					</ThemedBlock>
					
					<ThemedList
						data={ section.data }
						renderItem={ ({ item, index }) => {
							return renderItem({
								section,
								item
							});
						} }
					/>
				</VStack>
			)
		}
	})
	
	if( header !== undefined ) {
		return (
			<ThemedBlock
				header={ header }
				shadow>
				
				{ content }
			</ThemedBlock>
		);
	}
	
	return content;
}

export default ThemedSectionList
